export default "__VITE_ASSET__BZJHoyPw__"